import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  capitalizeWords,
  getFeedIconForFacebook, getFeedIconForInstagram,
  getFeedIconForReddit,
  getFeedIconForYoutube,
  getFeedIconForTiktok,
  getFeedIconForForum
} from '../../home/sharedFunctions';
import {
  CHARGED_POST_ICON_TOOLTIP,
  HEATED_COMMENTS_ICON_TOOLTIP,
  TOXIC_COMMENTS_ICON_TOOLTIP,
  MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT,
  MAX_HARM_WATCH_FEED_TITLE_LENGTH,
  HEATED_COMMENTS_PERCENTAGE_THRESHOLD,
  TOXIC_COMMENTS_PERCENTAGE_THRESHOLD
} from '../constants';
import { 
  ELLIPSES, 
  SEE_LESS, 
  SEE_MORE,
  CHARGED_POST_ICON_FILE_PATH,
  HEATED_COMMENTS_ICON_FILE_PATH,
  TOXIC_COMMENTS_ICON_FILE_PATH
} from './constants';
import { ALL } from '../../home/redux/constants';
import {
  FACEBOOK_PAGE_IN_SOURCE_NAME, INSTAGRAM_KEY,
  REDDIT_KEY,
  YOUTUBE_KEY,
  TIKTOK_KEY,
  FORUM_KEY
} from '../../home/components/constants/FeedCommentConstants';

export class HarmWatchFeed extends Component {
  static propTypes = {
    feed: PropTypes.object.isRequired,
    handleFeedDetails: PropTypes.func,
  }

  constructor(props) {
    super(props);

    this.state = {
      currentFeed: {
        feedDescription: "",
        feedTitle: "",
        feedMessage: "",
        feedDatetime: null,
        source: "",
        sourceLink: "",
      },
      feedMessageTextToDisplay: "",
      feedDescriptionTextToDisplay: "",
      feedMessageInOriginalLanguageToDisplay: "",
      feedDescriptionInOriginalLanguageToDisplay: "",
      fullTextDisplayButtonText: "",
      isMessageOrDescriptionTextTruncated: false,
      isSeeMore: false,
      relevantCommentCount: ""
    };
    this.wrapperRef = React.createRef();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidMount() {
    const feedMessage     = this.props.feed.feedMessage;
    const feedDescription = this.props.feed.feedDescription;
    let fullTextDisplayButtonText    = SEE_MORE;
    let feedMessageTextToDisplay     = this.props.feed.feedMessage.substring(0, MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT);
    let feedDescriptionTextToDisplay = this.props.feed.feedDescription.substring(0, MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT);
    let feedMessageInOriginalLanguageToDisplay     = "";
    let feedDescriptionInOriginalLanguageToDisplay = "";
    let isMessageOrDescriptionTextTruncated        = false;
    if (this.props.feed.isTranslated) {
      feedMessageInOriginalLanguageToDisplay     = this.props.feed.feedMessageInOriginalLanguage.substring(0,MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT);
      feedDescriptionInOriginalLanguageToDisplay = this.props.feed.feedDescriptionInOriginalLanguage.substring(0,MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT);

      if (this.props.feed.feedMessageInOriginalLanguage.length > MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT) {
        feedMessageInOriginalLanguageToDisplay += ELLIPSES;
        isMessageOrDescriptionTextTruncated = true;
      }
      if (this.props.feed.feedDescriptionInOriginalLanguage.length > MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT) {
        feedDescriptionInOriginalLanguageToDisplay += ELLIPSES;
        isMessageOrDescriptionTextTruncated = true;
      }
    }

    if (feedMessage.length >  MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT) {
      feedMessageTextToDisplay += ELLIPSES;
      isMessageOrDescriptionTextTruncated = true;
    }
    if (feedDescription.length >  MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT) {
      feedDescriptionTextToDisplay += ELLIPSES;
      isMessageOrDescriptionTextTruncated = true;
    }
    
    this.setState({
      currentFeed: this.props.feed,
      feedMessageTextToDisplay: feedMessageTextToDisplay,
      feedDescriptionTextToDisplay: feedDescriptionTextToDisplay,
      fullTextDisplayButtonText: fullTextDisplayButtonText,
      feedMessageInOriginalLanguageToDisplay:     feedMessageInOriginalLanguageToDisplay,
      feedDescriptionInOriginalLanguageToDisplay: feedDescriptionInOriginalLanguageToDisplay,
      isMessageOrDescriptionTextTruncated:        isMessageOrDescriptionTextTruncated
    });
  }

  handleClickOutside = event => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({isEllipsisActive: false });
    }
  }

  toggleFullTextDisplay = isSeeMore => {
    const {
      currentFeed
    } = this.state;
    if (isSeeMore) {
      this.setState({
        isSeeMore: isSeeMore,
        feedMessageTextToDisplay: currentFeed.feedMessage,
        feedDescriptionTextToDisplay: currentFeed.feedDescription,
        feedMessageInOriginalLanguageToDisplay: currentFeed.feedMessageInOriginalLanguage,
        feedDescriptionInOriginalLanguageToDisplay: currentFeed.feedDescriptionInOriginalLanguageToDisplay,
        fullTextDisplayButtonText: SEE_LESS
      });
    }
    else {
      let feedMessageTextToDisplay                   = this.props.feed.feedMessage.substring(0, MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT);
      let feedDescriptionTextToDisplay               = this.props.feed.feedDescription.substring(0, MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT);
      let feedMessageInOriginalLanguageToDisplay     = "";
      let feedDescriptionInOriginalLanguageToDisplay = "";
      if (this.props.feed.isTranslated) {
        feedMessageInOriginalLanguageToDisplay     = this.props.feed.feedMessageInOriginalLanguage.substring(0,MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT);
        feedDescriptionInOriginalLanguageToDisplay = this.props.feed.feedDescriptionInOriginalLanguage.substring(0,MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT);

        if (currentFeed.feedMessageInOriginalLanguage.length > MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT) {
          feedMessageInOriginalLanguageToDisplay += ELLIPSES;
        }
        if (currentFeed.feedDescriptionInOriginalLanguage.length > MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT) {
          feedDescriptionInOriginalLanguageToDisplay += ELLIPSES;
        }
      }
      if (currentFeed.feedMessage.length > MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT) {
        feedMessageTextToDisplay += ELLIPSES;
      }
      if (currentFeed.feedDescription.length > MAX_HARM_WATCH_FEED_TEXT_LENGTH_TO_SHOW_BY_DEFAULT) {
        feedDescriptionTextToDisplay += ELLIPSES;
      }
      
      this.setState({
        isSeeMore:                                  isSeeMore,
        feedMessageTextToDisplay:                   feedMessageTextToDisplay,
        feedDescriptionTextToDisplay:               feedDescriptionTextToDisplay,
        feedMessageInOriginalLanguageToDisplay:     feedMessageInOriginalLanguageToDisplay,
        feedDescriptionInOriginalLanguageToDisplay: feedDescriptionInOriginalLanguageToDisplay,
        fullTextDisplayButtonText:                  SEE_MORE
      });
    }
  }

  _getFeedCSSName = () => {
    const {currentFeed} = this.state;
    return currentFeed.source.toLowerCase();
  }

  _getFeedIcon = () => {
    const {currentFeed} = this.state;
    if (currentFeed.source.toLowerCase().includes(FACEBOOK_PAGE_IN_SOURCE_NAME)) {
      return getFeedIconForFacebook(currentFeed.source);
    }
    else if (currentFeed.source.toLowerCase() == REDDIT_KEY){
      return getFeedIconForReddit(currentFeed.sourceLink)
    }
    else if (currentFeed.source.toLowerCase() == YOUTUBE_KEY){
      return getFeedIconForYoutube()
    }
    else if (currentFeed.source.toLowerCase().includes(INSTAGRAM_KEY)){
      return getFeedIconForInstagram();
    }
    else if (currentFeed.source.toLowerCase().includes(TIKTOK_KEY)){
      return getFeedIconForTiktok();
    }
    else if (currentFeed.source.toLowerCase().includes(FORUM_KEY)){
      return getFeedIconForForum(currentFeed.source);
    }
    else {
      return currentFeed.source.toLowerCase();
    }
  }

  renderOriginalLanguageIfItIsTranslated(){
    const {
      currentFeed,
      feedMessageInOriginalLanguageToDisplay,
      feedDescriptionInOriginalLanguageToDisplay,
    } = this.state;
    return  currentFeed.isTranslated && (
      <div className="original-non-english">
        <div>
          <a href={currentFeed.sourceLink} target="_blank">
            <div className="vertical-line" />
            <h4 title={currentFeed.feedTitleInOriginalLanguage}
                className="harm-watch-feed-title-in-original-language">
              {currentFeed.feedTitleInOriginalLanguage}
            </h4>
            <div className="feed-original-content">
              {currentFeed.feedMessageInOriginalLanguage && (
                <h5 title={currentFeed.feedMessageInOriginalLanguage}>
                  {feedMessageInOriginalLanguageToDisplay}
                </h5>
              )}
              {(currentFeed.feedDescriptionInOriginalLanguage !== currentFeed.feedMessageInOriginalLanguage) && (
                <p className="harm-watch-feed-description-in-original-language">
                  {feedDescriptionInOriginalLanguageToDisplay}
                </p>
              )}
            </div>
          </a>
        </div>
      </div>
    )
  }

  _returnFeedTitleToDisplay() {
    const {currentFeed} = this.state;
    let feedTitleToDisplay = currentFeed.feedTitle.substring(0, MAX_HARM_WATCH_FEED_TITLE_LENGTH);
    if (currentFeed.feedTitle.length > MAX_HARM_WATCH_FEED_TITLE_LENGTH) {
      feedTitleToDisplay += ELLIPSES;
    }
    return feedTitleToDisplay;
  }

  _returnViewCommentsButtonLabel() {
    const {currentFeed} = this.state;
    let buttonLabel = "View " + String(currentFeed.relevantCommentCount);
    if (currentFeed.relevantCommentCount === 1) {
      buttonLabel += " Comment";
    }
    else {
      buttonLabel += " Comments";
    }
    return buttonLabel;
  }

  _determineIfFeedHasHeatedComments(currentFeed) {
    return (currentFeed.percentageOfHeatedComments >= HEATED_COMMENTS_PERCENTAGE_THRESHOLD);
  }

  _determineIfFeedHasToxicComments(currentFeed) {
    return (currentFeed.percentageOfToxicComments >= TOXIC_COMMENTS_PERCENTAGE_THRESHOLD);
  }

  _determineShouldShowHarmWatchFeedIcons(currentFeed, hasHeatedComments, hasToxicComments) {
    return (currentFeed.isChargedPost || hasHeatedComments || hasToxicComments);
  }
  
  render() {
    const {
      currentFeed,
      isSeeMore,
      feedMessageTextToDisplay,
      feedDescriptionTextToDisplay,
      fullTextDisplayButtonText,
      isMessageOrDescriptionTextTruncated
    } = this.state;
    const feedCSSName = this._getFeedCSSName();
    const feedTitleToDisplay = this._returnFeedTitleToDisplay();
    const hasHeatedComments = this._determineIfFeedHasHeatedComments(currentFeed);
    const hasToxicComments = this._determineIfFeedHasToxicComments(currentFeed);
    const shouldShowHarmWatchFeedIcons = this._determineShouldShowHarmWatchFeedIcons(
      currentFeed,
      hasHeatedComments,
      hasToxicComments
    );

    return (
      <div
        className="comment-card feeds harm-watch-feed"
      >
        <div className="feeds-description">
          <div
            className="feeds-button"
            ref={this.wrapperRef}
          >
            {shouldShowHarmWatchFeedIcons && (
              <div className='harm-watch-feed-icons-row'>
                {currentFeed.isChargedPost && (
                  <div className="harm-watch-header-pill-container">
                    <div
                      className="harm-watch-header-pill"
                      title={CHARGED_POST_ICON_TOOLTIP}
                    >
                      <img
                        src={CHARGED_POST_ICON_FILE_PATH}
                        alt={CHARGED_POST_ICON_TOOLTIP}
                      />
                    </div>
                  </div>
                )}
                {hasHeatedComments && (
                  <div className="harm-watch-header-pill-container">
                    <div
                      className="harm-watch-header-pill"
                      title={HEATED_COMMENTS_ICON_TOOLTIP}
                    >
                      <img
                        src={HEATED_COMMENTS_ICON_FILE_PATH}
                        alt={HEATED_COMMENTS_ICON_TOOLTIP}
                      />
                    </div>
                  </div>
                )}
                {hasToxicComments && (
                  <div className="harm-watch-header-pill-container">
                    <div
                      className="harm-watch-header-pill"
                      title={TOXIC_COMMENTS_ICON_TOOLTIP}
                    >
                      <img
                        src={TOXIC_COMMENTS_ICON_FILE_PATH}
                        alt={TOXIC_COMMENTS_ICON_TOOLTIP}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            <div className='harm-watch-feed-social-icon-div'>
              <div className={`social-button ${feedCSSName}`}>
                <span title={`${capitalizeWords(feedCSSName)}`}>
                  <img src={this._getFeedIcon()} alt=""/> 
                </span>
              </div>
              <h4
                className="harm-watch-feed-title"
                title={currentFeed.feedTitle}
              >
                {feedTitleToDisplay}
              </h4>
            </div>
          </div>
          <div className="harm-watch-feed-source">
            By: {currentFeed.source.replace('(facebook page)', '')} | {moment(currentFeed.feedDatetime).format('DD MMM YYYY hh:mm A')}
          </div>
          <hr />
          {(currentFeed.feedDescription !== currentFeed.feedMessage) && currentFeed.feedDescription && (
            <span>
              <h5 className="harm-watch-feed-description">
                {feedDescriptionTextToDisplay}
              </h5>
            </span>
          )}
          {currentFeed.feedMessage && (
            <div className="harm-watch-feed-message">
              <p className={isSeeMore ? 'shrink-text-view' : ''}>
                {feedMessageTextToDisplay}
              </p>
            </div>
          )}
          {this.renderOriginalLanguageIfItIsTranslated()}
          {isMessageOrDescriptionTextTruncated && (
            <button
              className="harm-watch-feed-see-more-button"
              onClick={() => this.toggleFullTextDisplay(!isSeeMore)}
            >
              <u>{fullTextDisplayButtonText}</u>
            </button>
          )}
            <div className="harm-watch-feed-footer">
                <div>
                  <button 
                    className="harm-watch-feed-view-comments-button"
                    onClick={() => this.props.handleFeedDetails(ALL)}
                  >
                    {this._returnViewCommentsButtonLabel()}
                    <div className="harm-watch-feeds-view-comments-spacer"></div>
                    <img src="/images/icons/view_comments_arrow.svg" alt="View Comments" />
                  </button>
                </div>
            </div>
          </div>
          {currentFeed.postImageUrl && (
              <img
                src={currentFeed.postImageUrl}
                className="harm-watch-feed-image"
                alt="Related to the article."
              />
          )}
      </div>
    )
  }
}

export default HarmWatchFeed;



// WEBPACK FOOTER //
// ./src/features/harmwatch/components/HarmWatchFeed.js